import { Icon } from "@mdi/react";
import { useState } from "react";

import { mdiFolderPlus } from "@mdi/js";
import { Tooltip } from "antd";
import styled from "styled-components";

import {
  ActionButton,
  FlexItem
} from "components/project/layers/components/layer-managers/shared";
import { useCreateProjectShapefileFolder } from "components/project/shapefiles/hooks/createProjectShapefileFolder/useCreateProjectShapefileFolder";

export default function SystemRootNode({ node, hasActions = true }) {
  const [tempFoldersLength, setTempFoldersLength] = useState(0);
  const createProjectFolder = useCreateProjectShapefileFolder({
    projectId: "system"
  });

  const handleCreateFolder = async () => {
    setTempFoldersLength((prev) => prev + 1);

    try {
      await createProjectFolder.mutateAsync({
        parentId: "",
        order: node.children.length + tempFoldersLength
      });
    } finally {
      setTempFoldersLength((prev) => prev - 1);
    }
  };

  return (
    <NodeTitle className="visible-always">
      <FlexItem>
        <label>{node.title}</label>
      </FlexItem>
      {hasActions && (
        <FlexItem>
          <Tooltip placement="top" title="Create New Folder">
            <ActionButton
              onClick={(evt) => {
                handleCreateFolder();
                evt.stopPropagation();
                evt.preventDefault();
              }}>
              <Icon path={mdiFolderPlus} size={1} />
            </ActionButton>
          </Tooltip>
        </FlexItem>
      )}
    </NodeTitle>
  );
}

const NodeTitle = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto auto;
  align-items: center;
  justify-content: space-between;

  ${ActionButton} {
    svg {
      opacity: 0;
    }
  }

  border: ${(props) => (props.canDrop ? "1px dashed green" : "none")};

  &:hover,
  &.visible-always,
  &.in-edit-mode {
    svg {
      opacity: 1;
    }
  }
`;
